// extracted by mini-css-extract-plugin
export default {"CancelSubscriptionContainer":"_CancelSubscriptionContainer--cYLDJ","Strong":"_Strong--LAcTN"};